import React from "react";

const Test: React.FC = () => {
  return <div style={{ width: "100%", height: "100%" }}></div>;
};

export default Test;
